import store from "../../app/store";
import { createAction } from "@reduxjs/toolkit";
import {
    ACTION_LAST_RULE_LOAD_CHANGED,
    ACTION_RULE_CHANGED,
    ACTION_RULE_REVERTED,
    ACTION_STATE_CLEANED
} from "./AddRulesPageReducer";
import { TargetTypes } from "./target-type/TargetTypeTab";
import { deepCopy } from "../../utils";

export function changeRule(rule) {
    store.dispatch(createAction(ACTION_RULE_CHANGED)({ rule: rule }))
}

export function cleanUpState() {
    store.dispatch(createAction(ACTION_STATE_CLEANED)());
}

export function revertRule() {
    store.dispatch(createAction(ACTION_RULE_REVERTED)());
}

export function changeLastRuleLoad() {
    store.dispatch(createAction(ACTION_LAST_RULE_LOAD_CHANGED)({ lastRuleLoad: Date.now() }))
}

export function changeTargetTypeElement(targetType, element, rule) {

    const ruleCopy = deepCopy(rule);

    switch (targetType) {
        case TargetTypes.DEVICE_TYPE:
            selectOrUnselectOneElement(ruleCopy.deviceTypes, element);
            break;
        case TargetTypes.COMPLIANCE:
            selectOrUnselectElement(ruleCopy.compliance, element);
            break;
        case TargetTypes.LOCATION:
            selectOrUnselectElement(ruleCopy.locations, element);
            break;
        case TargetTypes.SECTORS:
            selectOrUnselectElement(ruleCopy.sectors, element);
            break;
        case TargetTypes.MSB:
            selectOrUnselectOneElement(ruleCopy.msbList, element);
            break;
        case TargetTypes.GROUPS:
            selectOrUnselectElement(ruleCopy.groups, element);
            break;
        default:
            break;
    }

    store.dispatch(createAction(ACTION_RULE_CHANGED)({ rule: ruleCopy }))

}


export function patchTargetTypes(targetType, targetTypes, rule) {

    const targetTypesCopy = deepCopy(targetTypes);

    switch (targetType) {
        case TargetTypes.DEVICE_TYPE: {
            const deviceTypes = targetTypesCopy.deviceTypes;
            const ruleDeviceTypes = rule.deviceTypes;
            preSelectTargetTypes(ruleDeviceTypes, deviceTypes);
            return deviceTypes;
        }
        case TargetTypes.COMPLIANCE: {
            const compliance = targetTypesCopy.compliance;
            const ruleCompliance = rule.compliance;
            preSelectTargetTypes(ruleCompliance, compliance);
            return compliance;
        }
        case TargetTypes.LOCATION: {
            const locations = targetTypesCopy.locations;
            const ruleLocations = rule.locations;
            preSelectTargetTypes(ruleLocations, locations);
            return locations;
        }
        case TargetTypes.SECTORS: {
            const sectors = targetTypesCopy.sectors;
            const ruleSectors = rule.sectors;
            preSelectTargetTypes(ruleSectors, sectors);
            return sectors;
        }
        case TargetTypes.MSB: {
            const msbList = targetTypesCopy.msbList;
            let ruleMsbList = rule.msbList;
            preSelectTargetTypes(ruleMsbList, msbList);
            return msbList;
        }
        case TargetTypes.GROUPS: {
            const group = targetTypesCopy.groups;
            let ruleGroup = rule.groups;
            preSelectTargetTypes(ruleGroup, group);
            return group;
        }

        default:
            return null;
    }
}

function selectOrUnselectElement(collection, element) {
    if (element.selected) {
        const selected = collection.find(el => el.id === element.id);
        collection.splice(collection.indexOf(selected), 1)
    } else {
        collection.push(element);
    }
}

function selectOrUnselectOneElement(collection, element) {
    collection.length = 0;
    if (element.selected) {
        const selected = collection.find(el => el.id === element.id);
        collection.splice(collection.indexOf(selected), 1)
    } else {
        collection.push(element);
    }
}

function preSelectTargetTypes(ruleTargetTypes, allTargetTypes) {

    if (!ruleTargetTypes || !ruleTargetTypes.length) {
        ruleTargetTypes = [...allTargetTypes];
        return;
    }

    allTargetTypes.forEach(targetType => {
        const exist = ruleTargetTypes.find(tarType => tarType.id === targetType.id);
        if (exist) {
            targetType.selected = true;
        }
    })
}
